// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2r_bm","title":"AfterBackImages_title__2lvPe","images":"AfterBackImages_images__1m4cC"};